<template>
  <li class="notification-feed-item">
    <router-link v-if="notification.link_type" active-class="" :to="routerLinkPayload" :style="!routerLinkPayload ? 'cursor: default' : null">
      <notification-feed-item-body :notification="notification"/>
    </router-link>
    <a v-else-if="notification.link_url" :href="notification.link_url" target="_blank">
      <notification-feed-item-body :notification="notification"/>
    </a>
    <div
      v-else
      :class="notification.response_id ? 'disabled' : ''"
      data-toggle="modal"
      :data-target="`#modal-notification-response-${notification.notification.id}`"
      :style="hasResponses ? null : 'cursor: default'">
      <notification-feed-item-body :notification="notification"/>
    </div>
    <notification-response-modal
      v-if="hasResponses&& !notification.response_id"
      :notification="notification"/>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import NotificationResponseModal from './NotificationResponseModal'
import NotificationFeedItemBody from './NotificationFeedItemBody'
export default {
  props: {
    notification: {
      required: true,
      type: Object
    }
  },

  components: {
    NotificationFeedItemBody,
    NotificationResponseModal
  },

  computed: {
    ...mapState('notifications', ['linkTypeLookup']),
    routerLinkPayload () {
      if (!this.notification.link_type) {
        return null
      }
      if (this.notification.link_id) {
        return { name: this.linkTypeLookup[this.notification.link_type], params: { id: this.notification.link_id } }
      }
      return { name: this.linkTypeLookup[this.notification.link_type] }
    },

    hasResponses () {
      return this.notification.notification &&
        this.notification.notification.responses &&
        this.notification.notification.responses.length
    }
  }
}
</script>
